import { isInIframe } from '@widgets/shared/utils/isInIframe'
import { useWidgetPostMessages } from '@widgets/messenger/utils/postMessages'

const useGettingParentUrlMessages = (widgetId: string) =>
  useWidgetPostMessages<undefined>(widgetId, 'textmagicGetParentUrl')

const useSendingParentUrlMessages = (widgetId: string) =>
  useWidgetPostMessages<string /* url */>(widgetId, 'textmagicSendParentUrl')

export const subscribeAndHandleMessengerGetParentUrlMessages = (widgetId: string) => {
  return useGettingParentUrlMessages(widgetId).subscribe((event) => {
    useSendingParentUrlMessages(widgetId).reply(event, window.location.href)
  })
}

export const getParentUrl = async (widgetId: string) => {
  if (!isInIframe()) {
    return undefined
  }

  useGettingParentUrlMessages(widgetId).sendToParent(undefined)

  return new Promise<string>((resolve) => {
    useSendingParentUrlMessages(widgetId).subscribe((event) => {
      resolve(event.data.payload)
    })
  })
}
